import { ScrollArea, Separator, cn } from 'ui'
import { PagePDF, usePDFStore } from '../../stores/pdf.store'
import { buildPagePortalId } from './Viewer'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'ui'

type PageAttrs = Pick<PagePDF, 'id' | 'page' | 'file'>

const PageIndicator = ({
  page,
  documentId,
}: {
  page: PageAttrs
  documentId: string
}) => {
  const currentViewportPageId = usePDFStore(
    (state) => state.currentViewportPageId
  )

  return (
    <div
      onClick={() => {
        const pageElement = window.document.getElementById(
          buildPagePortalId(documentId, page.page)
        )!

        pageElement.scrollIntoView()
      }}
      key={page.id}
      className={cn(
        'w-32 h-44 border relative hover:border-primary transition-all cursor-pointer',
        {
          'border-primary': currentViewportPageId === page.id,
        }
      )}
    >
      <img loading='lazy' src={page.file.url} />
      <div className='bg-gray-100 p-1 absolute bottom-0 w-full'>
        <span className='text-muted-foreground text-xs'>{page.page + 1}</span>
      </div>
    </div>
  )
}

export const PagesIndicators = ({
  headerHeight,
  documents,
}: {
  headerHeight: `${number}rem`
  documents: {
    id: string
    name: string
    pages: PageAttrs[]
  }[]
}) => {
  return (
    <ScrollArea
      style={{
        height: `calc(100vh - ${headerHeight})`,
      }}
      className='overflow-y-auto [&>div>div]:!block shrink-0'
    >
      <p className='font-medium px-4 pt-4'>Documentos</p>

      <Separator className='my-4' />
      <Accordion type='single' collapsible>
        {documents.map((document) => {
          return (
            <AccordionItem key={document.id} value={document.id}>
              <AccordionTrigger className='px-4'>
                <span className='text-xs text-left font-normal truncate max-w-[240px]'>
                  {document.name}
                </span>
              </AccordionTrigger>
              <AccordionContent className='space-y-4'>
                <span className='text-gray-500 px-4'>
                  Paginas: {document.pages.length}
                </span>
                <div className='flex flex-col space-y-8 items-center'>
                  {document.pages.map((page) => (
                    <PageIndicator
                      documentId={document.id}
                      page={page}
                      key={`preview-page-${page.id}`}
                    />
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          )
        })}
      </Accordion>
    </ScrollArea>
  )
}

export const PDFViewerPagesIndicators = () => {
  const headerHeight = usePDFStore((state) => state.headerHeight)
  const documents = usePDFStore((state) => state.documents)

  return (
    <PagesIndicators
      headerHeight={headerHeight}
      documents={documents.map((document) => ({
        ...document,
        name: document.file.original_name,
      }))}
    />
  )
}
